export default __webpack_public_path__ + "static/media/cloud.e33020c7.svg";